// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"27d74639","239":"f61b8f84","455":"4b688784"}[chunkId] + ".chunk.js";
};